import { render, staticRenderFns } from "./stockallot.vue?vue&type=template&id=72e81470&scoped=true&"
import script from "./stockallot.vue?vue&type=script&lang=js&"
export * from "./stockallot.vue?vue&type=script&lang=js&"
import style0 from "./stockallot.vue?vue&type=style&index=0&lang=css&"
import style1 from "./stockallot.vue?vue&type=style&index=1&id=72e81470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e81470",
  null
  
)

export default component.exports